import threebottleu1 from "../../../assets/3bottle-u1.png"
import twelvebottleu1 from "../../../assets/9bottle-u1.png"
import sixbottleu1 from "../../../assets/Vsl6bottles.png"




export const pricingData = [
    {
        product: "https://cdn.blackincae.com/respoclear/4jI-3-bottles-u1-fe.png",
        title: '3 Bottles',
        subtitle: '90 Days Supply',
        pricePerBottle: 49,
        buttonLink:'https://upsender21_scalerespo.pay.clickbank.net/?cbitems=4&cbur=a',
        leastpopular: true,
        popular: false,
        freeshipping:'FAST & FREE SHIPPING',
        originalPrice: "597",
        discountedPrice: "147",
        bestValue: false,

    },
    {
        product: "https://cdn.blackincae.com/respoclear-resize/wBZ-9-bottles-u1.png",
        title: '9 Bottles',
        subtitle: '270 Days Supply',
        pricePerBottle: 29,
        buttonLink: "https://upsender21_scalerespo.pay.clickbank.net/?cbitems=5&cbur=a",
        leastpopular: false,
        popular: true,
        discount:' Biggest discount',
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
        originalPrice: "1,791 ",
        discountedPrice: "261",
        bestValue: true,

    }, {
        product: "https://cdn.blackincae.com/respoclear/pyL-6-bottle-u1.png",
        title: '6 Bottles ',
        subtitle: '180 Day Supply',
        pricePerBottle: 39,
        buttonLink: "https://upsender21_scalerespo.pay.clickbank.net/?cbitems=6&cbur=a",
        leastpopular: false,
        popular: false,
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
        originalPrice: "1,194 ",
        discountedPrice: "234",
        bestValue: false,

    },
]



export const images = [
    { id: "bottom-testi1", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-04.png", alt: "testi-3b-min jpg" },
    { id: "bottom-testi2", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-01.png", alt: "testi-7-min jpg" },
    { id: "bottom-testi3", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-03.png", alt: "testi-2-min (1) jpg" },
    { id: "bottom-testi4", src:"https://cdn.blackincae.com/product-images/sinoclear-feedback-02.png", alt: "testi-6-min jpg" },
];


 export const stores = [
    {
        name: 'Walgreens',
        logo: 'https://sinoclear.net/pm/images/X-Walgreens_2020_primary_logo.svg'
    },
    {
        name: 'Walmart',
        logo: 'https://sinoclear.net/pm/images/X-Walmart_logo.svg'
    },
    {
        name: 'GNC',
        logo: 'https://sinoclear.net/pm/images/x-gnc-live-well-2.svg'
    },
    {
        name: 'CVS',
        logo: 'https://sinoclear.net/pm/images/X-CVS_Pharmacy_Alt_Logo.svg'
    }
];


  export const studies = [
    { id: '01', url: 'https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette' },
    { id: '02', url: 'https://www.ncbi.nlm.nih.gov/pubmed/9932596' },
    { id: '03', url: 'https://www.ncbi.nlm.nih.gov/pubmed/25339490' },
    { id: '04', url: 'https://ijmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/' },
    { id: '05', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27117852' },
    { id: '06', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title' },
    { id: '07', url: 'https://www.sciencedirect.com/science/article/pii/S1756464614002400' },
    { id: '08', url: 'https://pubmed.ncbi.nlm.nih.gov/28198157/' },
    { id: '09', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27207147' },
    { id: '10', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/' },
    { id: '11', url: 'https://pubmed.ncbi.nlm.nih.gov/12452574/' },
    { id: '12', url: 'https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953' },
    { id: '13', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/' },
    { id: '14', url: 'https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/' },
    { id: '15', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/' },
    { id: '16', url: 'https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients' },
    { id: '17', url: 'https://pubmed.ncbi.nlm.nih.gov/22129334/' },
    { id: '18', url: 'https://www.ncbi.nlm.nih.gov/pubmed/18356331' },
    { id: '19', url: 'https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen' },
    { id: '20', url: 'https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),not%20as%20substitute%20for%20conventional%20chemotherapy' }
];